import { render, staticRenderFns } from "./UploadOrderItemsCsvDialog.vue?vue&type=template&id=48caba84&scoped=true"
import script from "./UploadOrderItemsCsvDialog.ts?vue&type=script&lang=ts&external"
export * from "./UploadOrderItemsCsvDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./UploadOrderItemsCsvDialog.scss?vue&type=style&index=0&id=48caba84&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48caba84",
  null
  
)

export default component.exports